import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import InputMask from 'react-input-mask';
import PlainInput from '../PlainInput';
import Label from '../Label';
import styles from './Input.css';
import Loading from '../../Loading';

const Input = ({
    input,
    id,
    label,
    inputStyle,
    inputClassName,
    mask,
    maskChar,
    type,
    min,
    max,
    className,
    style,
    children,
    labelStyle,
    autoComplete,
    disabled,
    labelClassName,
    help,
    placeholder,
    meta: { touched, asyncValidating, error, warning },
}) => {
    let info;
    let infoClassName;
    if (touched && error) {
        infoClassName = styles.error;
        info = error;
    } else if (touched && warning) {
        infoClassName = styles.warn;
        info = warning;
    } else if (help) {
        infoClassName = styles.help;
        info = typeof help === 'function' ?
            help(input.value) : help;
    } else if (asyncValidating) {
        infoClassName = styles.loading;
        info = (<Loading />);
    }
    let inputEl;
    if (mask) {
        inputEl = (<InputMask
            mask={mask}
            maskChar={maskChar || '_'}
            {...input}
            onChange={(e) => {
                e.preventDefault();
                input.onChange(e.target.value);
            }}
            value={input.value}
            disabled={disabled}
            formatChars={{
                9: '[0-9]',
                a: '[A-Za-z]',
                '*': '[A-Za-z0-9]',
                m: '[0-9]',
                y: '[0-9]',
                d: '[0-9]',
            }}
            autoComplete={autoComplete}
            placeholder={placeholder}
        >
            {passProps => <PlainInput
                id={id}
                style={inputStyle}
                className={inputClassName}
                type={type}
                {...passProps}
            />}
        </InputMask>);
    } else {
        inputEl = (<PlainInput
            id={id}
            style={inputStyle}
            className={inputClassName}
            type={type}
            min={min}
            max={max}
            disabled={disabled}
            autoComplete={autoComplete}
            placeholder={placeholder}
            {...input}
        />);
    }
    return (<div
        className={cx(styles.container, className)}
        style={style}
    >
        <Label
            name={input.name}
            text={label}
            hidden={!label}
            htmlFor={input.name}
            className={labelClassName}
            style={labelStyle}
            id={`label-${id || input.name}`}
        />
        {inputEl}
        {children}
        {info ? <span className={cx(styles.info, infoClassName)}>
            {info}
        </span> : null}
    </div>);
};

Input.propTypes = {
    label: PropTypes.node,
    type: PropTypes.string,
    id: PropTypes.string,
    autoComplete: PropTypes.string,
    mask: PropTypes.string,
    maskChar: PropTypes.string,
    min: PropTypes.string,
    max: PropTypes.string,
    input: PropTypes.object,
    inputStyle: PropTypes.object,
    labelStyle: PropTypes.object,
    style: PropTypes.object,
    meta: PropTypes.object,
    className: PropTypes.string,
    help: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.func,
    ]),
    children: PropTypes.node,
    labelClassName: PropTypes.string,
    inputClassName: PropTypes.string,
    disabled: PropTypes.bool,
    placeholder: PropTypes.string,
};

Input.defaultProps = {
    meta: {},
};

export default Input;



// WEBPACK FOOTER //
// ./src/client/Components/Forms/Input/Input.js